import { render, staticRenderFns } from "./NeedsCommentBubble.vue?vue&type=template&id=294f2ac2&scoped=true&"
import script from "./NeedsCommentBubble.vue?vue&type=script&lang=js&"
export * from "./NeedsCommentBubble.vue?vue&type=script&lang=js&"
import style0 from "./NeedsCommentBubble.vue?vue&type=style&index=0&id=294f2ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f2ac2",
  null
  
)

export default component.exports